/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
    "i18n/i18n",
    "api/v2/common",
    "api/v2/search",
    "backbone",
    "underscore",
    "model/tree",
    "model/readonlytree",
    "service/stub",
    "service/factory",
    "client/client-extensions/result-enriching-response-observer"
  ], function(
    i18n,
    Common,
    Search,
    Backbone,
    _,
    TreeModel,
    ReadOnlyTreeModel,
    Stub,
    ServiceFactory,
    ResultEnrichingResponseObserver
  ){

  var Preview = {};

  Preview.API_PATH = "preview";

  var PreviewResponse = Preview.PreviewResponse = {      
    parseResult: function (result, options) {
      result = _.clone(result);
      result.properties = Common.Properties.parse({}, result.properties, options);
      return result;        
    },
    
    parse: function (response, options) {
      response = _.clone(response);
      if (response.result)
        response.result = PreviewResponse.parseResult(response.result, options);        

      response.status_messages = Common.StatusMessages.parse(response.status_messages);
      return response;
    }
  }

  
  var PreviewServiceStub = Preview.PreviewServiceStub = Stub.extend({
    path: Preview.API_PATH,
    options: {defaultAjaxRequestTimeoutInMs: 60000},

    call: function(channel, previewRequest, responseObserver) {
      return Stub.prototype.call.apply(this, [channel, previewRequest, responseObserver]);
    }
  });


  var PreviewInputModel = Preview.PreviewInputModel = TreeModel.extend({
    toJSON: function(options) {
      options = options || {};

      var attrs = this.attributes;
      var json = _.clone(attrs);
      
      if (json.query_expr) {
        json.query_expr = Search.SearchRequest.jsonifyQueryExpr(json.query_expr);
      }

      if(json.properties) {
        json.properties =  Search.SearchRequest.jsonifyPropertyDefinitions(json.properties);

        if (options.resultPropertyEnrichmentHandler) {
          json.properties = options.resultPropertyEnrichmentHandler
            .transformRequestedProperties(json.properties);
        }
      }

      return json;
    }
  });
  
  var PreviewOutputModel = Preview.PreviewOutputModel = ReadOnlyTreeModel.extend({
    parseAsync: function (response, options) {
      var parsedResult = Preview.PreviewResponse.parse(response);

      if (parsedResult.result && parsedResult.result.properties && options.resultPropertyEnrichmentHandler) {
        return options.resultPropertyEnrichmentHandler.result(parsedResult.result.properties)
          .then(function(enrichedProperties) {
            parsedResult.result.properties = enrichedProperties;
            return parsedResult;
          }); 
      }

      return Promise.resolve(parsedResult);
    },

    parse: function (response) {      
      return Preview.PreviewResponse.parse(response);
    }
  });
  
  var PreviewServiceFactory = Preview.ServiceFactory = function() {}
  
  _.extend(PreviewServiceFactory.prototype, ServiceFactory.prototype, {
    call: function (channel, previewRequestOrModel, callback, options) {
      options = options || {};
      
      var model = this.createOutput();
      var responseObserver;

      if (_.isFunction(callback)) {
        var modelOptions = {
          traceContext: options.traceContext,
          clientExtensions: options.clientExtensions
        };
        
        var observerOptions = {
          handlerOptions: { api: Preview.API_PATH }
        };

        responseObserver = this._responseObserver = new ResultEnrichingResponseObserver(
          model, 
          modelOptions,
          observerOptions
        );

        this._responseObserver.on("response", function (response) {

          responseObserver.resetModel(response, { parse: true }).then(function(val, error){
            try {
              responseObserver.finalize();
              callback(model, error);
            } catch (e) {
              if (console && console.error) console.error(e, e.stack);
            }
          });
         
        });

        this._responseObserver.on("error", function (error) {
          try {
            responseObserver.finalize();
            callback(null, error);
          } catch (e) {
            if (console && console.error) console.error(e, e.stack);
          }
        });
      }

      var serializeRequest = function(model) {
        var modelOptions = (responseObserver && _.isFunction(responseObserver.getAdditionalModelOptions) && responseObserver.getAdditionalModelOptions()) || {};
        return model.toJSON(modelOptions);
      }

      var previewRequest = _.isFunction(previewRequestOrModel.toJSON) 
        ? serializeRequest(previewRequestOrModel)
        : previewRequestOrModel;

      new PreviewServiceStub().call(channel, previewRequest, responseObserver);
    },
        

    createInput:  function(attrs,options) { return new PreviewInputModel(attrs, options); },
    createOutput: function(attrs,options) { return new PreviewOutputModel(attrs, options); }
    /*,
    createModel:  function(channel, options) {
      options = options || {};
      options.serviceStub = options.serviceStub || new PreviewServiceStub();
      return new PreviewModel(this.createWiring(channel,options), options);
    }*/
  });

  return Preview;
});
